// extracted by mini-css-extract-plugin
export default {"mCard":"qC-z","image":"rC-z","imageNoBackground":"sC-z","imageHasCategory":"tC-z","fullWidth":"uC-z"};